import { HeadLine } from '../../layouts/headers/HeadLine';
import CSS from 'csstype';
import { useState } from 'react';
import { SliderImages } from '../../components/swipper/SliderImages';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export const GymMainPage = () => {

    const [scrollpos, setScrollpos] = useState(260);

    const checkIcon = <FontAwesomeIcon icon={faCheck} color='#67BAAF' />

    const images = [
        '/assets/img/gym_1.png',
        '/assets/img/gym_2.png',
        '/assets/img/gym_1.png',
        '/assets/img/gym_2.png'
    ];

    const bgimage: CSS.Properties = { background: "linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.3) 100%), url('/assets/img/gym_bg.png') no-repeat center center / cover" };


    const handleScroll = (e) => {

        let posmin = window.innerHeight - e.target.scrollHeight;
        if (e.target.scrollTop > 0) {
            setScrollpos(posmin > 77 ? posmin : 77);
        } else {
            setScrollpos(260);
        }

    }

    return (
        <>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Fitness Center' backurl='/' />
            </div>


            <div className="w-full relative content-hi-sm">
                <div className="bg_room_page flex justify-center items-center bg_page_top" style={bgimage}>
                    <img src="/assets/img/icons/fitness-icon.svg" alt="Icono room" />
                </div>
            </div>

            <div className="absolute z-1 w-full border shadow detail-experience-container pb-4 bg_page_top"
                onScroll={handleScroll} style={{ height: `calc(100% - ${scrollpos}px)` }}>

                <div className='flex justify-start items-center mt-4 mb-4 gap-10' style={{ color: '#4B5563' }}>
                    <div className='inline-flex items-center'>
                        <img src="/assets/img/icons/clock-icon.svg" alt="clock icon" className='mr-1' width={'26px'} height={'26px'} />
                        <strong>Abre:</strong>&nbsp; 6:00 a.m.
                    </div>
                    <div>
                        <strong>Abre:</strong>&nbsp; 6:00 a.m.
                    </div>
                </div>

                <SliderImages onclickitem={() => { }} items={images} />


                <div className='flex flex-col gap-4 mt-4'>
                    <div>{checkIcon}&nbsp; Equipo de entrenamiento cardiovascular</div>
                    <div>
                        {checkIcon}&nbsp; Servicios del gimnasio: Saunas para hombres y mujeres separados.
                    </div>

                    <div>
                        {checkIcon}&nbsp; Privilegios especiales de los huéspedes: Acceso gratis.
                    </div>

                    <div>
                        {checkIcon}&nbsp; Pesas
                    </div>
                </div>


            </div>
        </>
    );
};